<template lang="html">
  <div class="toggable-hint-panel"><a v-show="!opened" href="#" @click.prevent="onClickLink"
                                      class="link-hovered toggable-hint-panel-toggle-link"><span>{{
      linkTextAuto
    }}</span></a>
    <payout-hint-panel v-show="opened" :heading="heading">
      <template v-slot:heading>
        <div class="row">
          <div class="col-xs-10">{{ heading }}</div>
          <div class="col-xs-2 text-right"><a href="#" @click.prevent="onClickClose"><i
            class="glyphicon glyphicon-remove-circle"></i></a></div>
        </div>
      </template>
      <slot></slot>
    </payout-hint-panel>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import PayoutHintPanel from './PayoutHintPanel.vue';

@Component({
  name: 'payout-toggable-hint-panel',
  components: {PayoutHintPanel},
})
export default class PayoutToggableHintPanel extends Vue {
  @Prop({default: ''})
  heading: string | null

  @Prop({default: null})
  linkText: string | null

  opened = false

  get linkTextAuto(): string {
    return '' + (this.linkText ? this.linkText : this.heading);
  }

  onClickLink() {
    this.openPanel();
  }

  onClickClose() {
    this.closePanel();
  }

  openPanel() {
    this.opened = true;
  }

  closePanel() {
    this.opened = false;
  }
}
</script>

<style scoped>

</style>
